// extracted by mini-css-extract-plugin
export default {"main":"Advertise_main__I3glW"};